'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var isString = _interopDefault(require('lodash/isString'));
var isFunction = _interopDefault(require('lodash/isFunction'));
var isArray = _interopDefault(require('lodash/isArray'));
var isObject = _interopDefault(require('lodash/isObject'));
var fetch = require('cross-fetch');
var fetch__default = _interopDefault(fetch);
var inRange = _interopDefault(require('lodash/inRange'));
var some = _interopDefault(require('lodash/some'));
var noop = _interopDefault(require('lodash/noop'));
var chunk = _interopDefault(require('lodash/chunk'));
var cloneDeepWith = _interopDefault(require('lodash/cloneDeepWith'));

// Copyright 2020 Cognite AS
/** @hidden */
var DEFAULT_CLUSTER = 'api';
/** @hidden */
var DEFAULT_DOMAIN = 'cognitedata.com';
/** @hidden */
var BASE_URL = "https://" + DEFAULT_CLUSTER + "." + DEFAULT_DOMAIN;
/** @hidden */
var AUTHORIZATION_HEADER = 'Authorization';
/** @hidden */
var API_KEY_HEADER = 'api-key';
/** @hidden */
var X_CDF_APP_HEADER = 'x-cdp-app';
/** @hidden */
var X_CDF_SDK_HEADER = 'x-cdp-sdk';
/** @hidden */
var X_REQUEST_ID = 'x-request-id';
/** @hidden */
var LOCAL_STORAGE_PREFIX = '@cognite/sdk:';

var constants = /*#__PURE__*/Object.freeze({
    __proto__: null,
    DEFAULT_CLUSTER: DEFAULT_CLUSTER,
    DEFAULT_DOMAIN: DEFAULT_DOMAIN,
    BASE_URL: BASE_URL,
    AUTHORIZATION_HEADER: AUTHORIZATION_HEADER,
    API_KEY_HEADER: API_KEY_HEADER,
    X_CDF_APP_HEADER: X_CDF_APP_HEADER,
    X_CDF_SDK_HEADER: X_CDF_SDK_HEADER,
    X_REQUEST_ID: X_REQUEST_ID,
    LOCAL_STORAGE_PREFIX: LOCAL_STORAGE_PREFIX
});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

// Copyright 2020 Cognite AS
/** @hidden */
var Queue = /** @class */ (function () {
    function Queue() {
        var _this = this;
        this.add = function (item) {
            _this.data.unshift(item);
        };
        this.remove = function () {
            _this.data.pop();
        };
        this.first = function () {
            return _this.data[0];
        };
        this.last = function () {
            return _this.data[_this.data.length - 1];
        };
        this.size = function () {
            return _this.data.length;
        };
        this.data = [];
    }
    return Queue;
}());

// Copyright 2020 Cognite AS
/** @hidden */
function topologicalSort(nodes) {
    var e_1, _a;
    var queue = new Queue();
    var sortedList = [];
    var childrenMap = getChildrenMap(nodes);
    try {
        // insert root nodes
        for (var nodes_1 = __values(nodes), nodes_1_1 = nodes_1.next(); !nodes_1_1.done; nodes_1_1 = nodes_1.next()) {
            var node = nodes_1_1.value;
            if (!node.parentNode) {
                queue.add(node);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (nodes_1_1 && !nodes_1_1.done && (_a = nodes_1.return)) _a.call(nodes_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    while (queue.size() !== 0) {
        var node = queue.last();
        queue.remove();
        sortedList.push(node);
        var children = childrenMap.get(node);
        if (children) {
            children.forEach(queue.add);
        }
    }
    if (sortedList.length !== nodes.length) {
        throw Error('Impossible to topological sort nodes');
    }
    return sortedList;
}
function getChildrenMap(nodes) {
    var e_2, _a, e_3, _b;
    var childrenMap = new Map();
    try {
        for (var nodes_2 = __values(nodes), nodes_2_1 = nodes_2.next(); !nodes_2_1.done; nodes_2_1 = nodes_2.next()) {
            var node = nodes_2_1.value;
            childrenMap.set(node, []);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (nodes_2_1 && !nodes_2_1.done && (_a = nodes_2.return)) _a.call(nodes_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
    try {
        for (var nodes_3 = __values(nodes), nodes_3_1 = nodes_3.next(); !nodes_3_1.done; nodes_3_1 = nodes_3.next()) {
            var node = nodes_3_1.value;
            var parentNode = node.parentNode;
            if (parentNode) {
                childrenMap.get(parentNode).push(node);
            }
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (nodes_3_1 && !nodes_3_1.done && (_b = nodes_3.return)) _b.call(nodes_3);
        }
        finally { if (e_3) throw e_3.error; }
    }
    return childrenMap;
}

var graphUtils = /*#__PURE__*/Object.freeze({
    __proto__: null,
    topologicalSort: topologicalSort
});

/** @hidden */
function getHeaderField(headers, key) {
    var lowercaseKey = key.toLowerCase();
    for (var headerKey in headers) {
        if (headerKey.toLowerCase() === lowercaseKey) {
            return headers[headerKey];
        }
    }
    return undefined;
}

var CogniteError = /** @class */ (function (_super) {
    __extends(CogniteError, _super);
    /** @hidden */
    function CogniteError(errorMessage, status, requestId, otherFields) {
        if (otherFields === void 0) { otherFields = {}; }
        var _this = this;
        var message = errorMessage + " | code: " + status;
        if (requestId) {
            message += " | X-Request-ID: " + requestId;
        }
        var missing = otherFields.missing, duplicated = otherFields.duplicated, extra = otherFields.extra;
        if (missing || duplicated) {
            message += "\n" + JSON.stringify(otherFields, null, 2);
        }
        _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, CogniteError.prototype); // https://stackoverflow.com/questions/51229574/why-instanceof-returns-false-for-a-child-object-in-javascript
        _this.errorMessage = errorMessage;
        _this.status = status;
        _this.requestId = requestId;
        _this.missing = missing;
        _this.duplicated = duplicated;
        _this.extra = extra;
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, _this.constructor);
        }
        else {
            _this.stack = new Error(message).stack;
        }
        return _this;
    }
    CogniteError.prototype.toJSON = function () {
        var jsonObject = {
            status: this.status,
            message: this.errorMessage,
        };
        if (this.requestId) {
            jsonObject.requestId = this.requestId;
        }
        if (this.missing) {
            jsonObject.missing = this.missing;
        }
        if (this.duplicated) {
            jsonObject.duplicated = this.duplicated;
        }
        if (this.extra) {
            jsonObject.extra = this.extra;
        }
        return jsonObject;
    };
    return CogniteError;
}(Error));
/** @hidden */
function handleErrorResponse(err) {
    var code;
    var duplicated;
    var extra;
    var message;
    var missing;
    var requestId;
    try {
        code = err.status;
        var data = err.data;
        duplicated = data.error.duplicated;
        message = data.error.message;
        missing = data.error.missing;
        extra = data.error.extra;
        requestId = getHeaderField(err.headers || {}, X_REQUEST_ID);
    }
    catch (_) {
        throw err;
    }
    throw new CogniteError(message, code, requestId, {
        duplicated: duplicated,
        extra: extra,
        missing: missing,
    });
}

// Copyright 2020 Cognite AS
function serialiseErrors(errors) {
    return errors.map(function (err) {
        if (err instanceof CogniteError) {
            return err;
        }
        var message = err.message, name = err.name, stack = err.stack;
        return { name: name, message: message, stack: stack };
    });
}
var CogniteMultiError = /** @class */ (function (_super) {
    __extends(CogniteMultiError, _super);
    function CogniteMultiError(_a) {
        var e_1, _b;
        var succeded = _a.succeded, responses = _a.responses, failed = _a.failed, errors = _a.errors;
        var _this = _super.call(this, "The API Failed to process some items\n" + JSON.stringify({
            succeded: succeded,
            responses: responses,
            failed: failed,
            errors: serialiseErrors(errors),
        }, null, 2)) || this;
        _this.missing = [];
        _this.duplicated = [];
        _this.statuses = [];
        _this.requestIds = [];
        _this.responses = [];
        Object.setPrototypeOf(_this, CogniteMultiError.prototype); // https://stackoverflow.com/questions/51229574/why-instanceof-returns-false-for-a-child-object-in-javascript
        _this.responses = responses.map(function (response) { return response.data; });
        _this.errors = errors;
        _this.succeded = succeded.reduce(function (all, current) { return all.concat(current); }, []);
        _this.failed = failed.reduce(function (all, current) { return all.concat(current); }, []);
        _this.status = errors[0].status;
        _this.requestId = errors[0].requestId;
        try {
            for (var errors_1 = __values(errors), errors_1_1 = errors_1.next(); !errors_1_1.done; errors_1_1 = errors_1.next()) {
                var err = errors_1_1.value;
                if (err instanceof CogniteError) {
                    if (err.missing) {
                        _this.missing = _this.missing.concat(err.missing);
                    }
                    if (err.duplicated) {
                        _this.duplicated = _this.duplicated.concat(err.duplicated);
                    }
                    if (err.requestId) {
                        _this.requestIds.push(err.requestId);
                    }
                    _this.statuses.push(err.status);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (errors_1_1 && !errors_1_1.done && (_b = errors_1.return)) _b.call(errors_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, _this.constructor);
        }
        else {
            _this.stack = new Error(_this.message).stack;
        }
        return _this;
    }
    return CogniteMultiError;
}(Error));

// Copyright 2020 Cognite AS
/** @hidden */
function getBaseUrl(baseUrl) {
    return baseUrl || BASE_URL;
}
/** @hidden */
var apiUrl = function (apiVersion) {
    if (apiVersion === void 0) { apiVersion = 'v1'; }
    return "/api/" + apiVersion;
};
/** @hidden */
function projectUrl(project, apiVersion) {
    if (apiVersion === void 0) { apiVersion = 'v1'; }
    return apiUrl(apiVersion) + "/projects/" + encodeURIComponent(project);
}
/** @hidden */
function bearerString(token) {
    return "Bearer " + token;
}
/** @hidden */
function isBrowser() {
    return (typeof window !== 'undefined' && typeof window.document !== 'undefined');
}
function isBuffer(obj) {
    // Taken from:
    // https://github.com/feross/is-buffer/blob/ec4bf3415108e8971375e6717ad63dde752faebf/index.js#L8
    return (obj != null &&
        obj.constructor != null &&
        typeof obj.constructor.isBuffer === 'function' &&
        obj.constructor.isBuffer(obj));
}
function clearParametersFromUrl() {
    var e_1, _a;
    var params = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        params[_i] = arguments[_i];
    }
    var url = window.location.href;
    try {
        for (var params_1 = __values(params), params_1_1 = params_1.next(); !params_1_1.done; params_1_1 = params_1.next()) {
            var param = params_1_1.value;
            url = removeQueryParameterFromUrl(url, param);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (params_1_1 && !params_1_1.done && (_a = params_1.return)) _a.call(params_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    window.history.replaceState(null, '', url);
}
/** @hidden */
function removeQueryParameterFromUrl(url, parameter) {
    return url
        .replace(new RegExp("[?#&]" + parameter + "=[^&#]*(#.*)?$"), '$1')
        .replace(new RegExp("([?#&])" + parameter + "=[^&]*&"), '$1');
}
/** @hidden */
function isJson(data) {
    return ((isArray(data) || isObject(data)) &&
        !isBuffer(data) &&
        !(data instanceof ArrayBuffer) &&
        !(data instanceof Date));
}
/** @hidden */
function sleepPromise(durationInMs) {
    return new Promise(function (resolve) {
        setTimeout(resolve, durationInMs);
    });
}
/**
 * Resolves all Promises at once, even if some of them fail
 */
/** @hidden */
function promiseAllAtOnce(inputs, promiser) {
    return __awaiter(this, void 0, void 0, function () {
        var failed, succeded, responses, errors, promises, wrappedPromises, results, results_1, results_1_1, res;
        var e_2, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    failed = [];
                    succeded = [];
                    responses = [];
                    errors = [];
                    promises = inputs.map(promiser);
                    wrappedPromises = promises.map(function (promise, index) {
                        return new Promise(function (resolve) {
                            promise
                                .then(function (result) {
                                resolve({ succeded: inputs[index], response: result });
                            })
                                .catch(function (error) {
                                resolve({ failed: inputs[index], error: error });
                            });
                        });
                    });
                    return [4 /*yield*/, Promise.all(wrappedPromises)];
                case 1:
                    results = _b.sent();
                    try {
                        for (results_1 = __values(results), results_1_1 = results_1.next(); !results_1_1.done; results_1_1 = results_1.next()) {
                            res = results_1_1.value;
                            failed.push.apply(failed, __spread((res.failed ? [res.failed] : [])));
                            succeded.push.apply(succeded, __spread((res.succeded ? [res.succeded] : [])));
                            responses.push.apply(responses, __spread((res.response ? [res.response] : [])));
                            errors.push.apply(errors, __spread((res.error ? [res.error] : [])));
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (results_1_1 && !results_1_1.done && (_a = results_1.return)) _a.call(results_1);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                    if (failed.length) {
                        throw {
                            succeded: succeded,
                            responses: responses,
                            failed: failed,
                            errors: errors,
                        };
                    }
                    return [2 /*return*/, responses];
            }
        });
    });
}
/** @hidden */
function promiseAllWithData(inputs, promiser, runSequentially) {
    return __awaiter(this, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    if (!runSequentially) return [3 /*break*/, 2];
                    return [4 /*yield*/, promiseEachInSequence(inputs, promiser)];
                case 1: return [2 /*return*/, _a.sent()];
                case 2: return [4 /*yield*/, promiseAllAtOnce(inputs, promiser)];
                case 3: return [2 /*return*/, _a.sent()];
                case 4:
                    err_1 = _a.sent();
                    throw new CogniteMultiError(err_1);
                case 5: return [2 /*return*/];
            }
        });
    });
}
/**
 * Resolves Promises sequentially
 */
/** @hidden */
function promiseEachInSequence(inputs, promiser) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            return [2 /*return*/, inputs.reduce(function (previousPromise, input, index) { return __awaiter(_this, void 0, void 0, function () {
                    var prevResult, _a, _b, err_2;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0: return [4 /*yield*/, previousPromise];
                            case 1:
                                prevResult = _c.sent();
                                _c.label = 2;
                            case 2:
                                _c.trys.push([2, 4, , 5]);
                                _b = (_a = prevResult).concat;
                                return [4 /*yield*/, promiser(input)];
                            case 3: return [2 /*return*/, _b.apply(_a, [_c.sent()])];
                            case 4:
                                err_2 = _c.sent();
                                throw {
                                    errors: [err_2],
                                    failed: inputs.slice(index),
                                    succeded: inputs.slice(0, index),
                                    responses: prevResult,
                                };
                            case 5: return [2 /*return*/];
                        }
                    });
                }); }, Promise.resolve(new Array()))];
        });
    });
}
/** @hidden */
function isSameProject(project1, project2) {
    return project1.toLowerCase() === project2.toLowerCase();
}
/** @hidden */
function applyIfApplicable(args, action) {
    if (action) {
        return action(args);
    }
    return args;
}
/** @hidden */
function generatePopupWindow(url, name) {
    return window.open(url, name, 
    // https://www.quackit.com/javascript/popup_windows.cfm
    'height=500,width=400,left=100,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes');
}
/** @hidden */
function createInvisibleIframe(url, name) {
    var iframe = document.createElement('iframe');
    iframe.name = name;
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';
    iframe.style.border = 'none';
    iframe.style.visibility = 'hidden';
    iframe.setAttribute('id', name);
    iframe.setAttribute('aria-hidden', 'true');
    iframe.src = url;
    return iframe;
}
/** @hidden */
function isUsingSSL() {
    return isBrowser() && location.protocol.toLowerCase() === 'https:';
}
/** @hidden */
function isLocalhost() {
    return isBrowser() && location.hostname === 'localhost';
}

var HttpError = /** @class */ (function (_super) {
    __extends(HttpError, _super);
    /** @hidden */
    function HttpError(status, data, headers) {
        var _this = _super.call(this, "Request failed | status code: " + status) || this;
        _this.status = status;
        _this.data = data;
        _this.headers = headers;
        Object.setPrototypeOf(_this, HttpError.prototype); // https://stackoverflow.com/questions/51229574/why-instanceof-returns-false-for-a-child-object-in-javascript
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, _this.constructor);
        }
        else {
            _this.stack = new Error(_this.message).stack;
        }
        return _this;
    }
    return HttpError;
}(Error));

// Copyright 2020 Cognite AS
var BasicHttpClient = /** @class */ (function () {
    /**
     * A basic http client with the option of adding default headers,
     * and the option of using a baseUrl.
     * Note: If the path given starts with `https://`, the baseUrl is ignored.
     *
     * It handles query parameters, and request body data which gets encoded as json if
     * needed.
     *
     * See HttpRequest.
     *
     * @param baseUrl
     */
    function BasicHttpClient(baseUrl) {
        var _this = this;
        this.baseUrl = baseUrl;
        this.defaultHeaders = {};
        this.setCluster = function (cluster) {
            _this.baseUrl = "https://" + cluster + "." + DEFAULT_DOMAIN;
        };
    }
    BasicHttpClient.validateStatusCode = function (status) {
        return status >= 200 && status < 300;
    };
    BasicHttpClient.throwCustomErrorResponse = function (response) {
        throw new HttpError(response.status, response.data, response.headers);
    };
    BasicHttpClient.jsonResponseHandler = function (res) {
        return res.json();
    };
    BasicHttpClient.textResponseHandler = function (res) {
        return res.text();
    };
    BasicHttpClient.arrayBufferResponseHandler = function (res) {
        return res
            .blob()
            .then(function (blob) {
            return new fetch.Response(blob).arrayBuffer();
        });
    };
    BasicHttpClient.getResponseHandler = function (responseType) {
        switch (responseType) {
            case HttpResponseType.ArrayBuffer:
                return BasicHttpClient.arrayBufferResponseHandler;
            case HttpResponseType.Text:
                return BasicHttpClient.textResponseHandler;
            default:
                return BasicHttpClient.jsonResponseHandler;
        }
    };
    BasicHttpClient.convertFetchHeaders = function (fetchHeaders) {
        var headers = {};
        fetchHeaders.forEach(function (value, key) {
            headers[key] = value;
        });
        return headers;
    };
    BasicHttpClient.transformRequestBody = function (data) {
        var isJSONStringifyable = isJson(data);
        if (isJSONStringifyable) {
            return JSON.stringify(data, null, 2);
        }
        return data;
    };
    BasicHttpClient.resolveUrl = function (baseUrl, path) {
        var trimmedBaseUrl = baseUrl.replace(/\/$/, '');
        var pathWithPrefix = (path[0] === '/' ? '' : '/') + path;
        return trimmedBaseUrl + pathWithPrefix.replace(/\/+$/, '');
    };
    BasicHttpClient.prototype.setDefaultHeader = function (name, value) {
        this.defaultHeaders[name] = value;
        return this;
    };
    BasicHttpClient.prototype.getDefaultHeaders = function () {
        return __assign({}, this.defaultHeaders);
    };
    BasicHttpClient.prototype.setBaseUrl = function (baseUrl) {
        this.baseUrl = baseUrl;
    };
    BasicHttpClient.prototype.getBaseUrl = function () {
        return this.baseUrl;
    };
    BasicHttpClient.prototype.get = function (path, options) {
        if (options === void 0) { options = {}; }
        return this.request(__assign(__assign({}, options), { path: path, method: exports.HttpMethod.Get }));
    };
    // TODO: responseType -> factory pattern
    BasicHttpClient.prototype.post = function (path, options) {
        if (options === void 0) { options = {}; }
        return this.request(__assign(__assign({}, options), { path: path, method: exports.HttpMethod.Post }));
    };
    BasicHttpClient.prototype.put = function (path, options) {
        if (options === void 0) { options = {}; }
        return this.request(__assign(__assign({}, options), { path: path, method: exports.HttpMethod.Put }));
    };
    BasicHttpClient.prototype.delete = function (path, options) {
        if (options === void 0) { options = {}; }
        return this.request(__assign(__assign({}, options), { path: path, method: exports.HttpMethod.Delete }));
    };
    BasicHttpClient.prototype.patch = function (path, options) {
        if (options === void 0) { options = {}; }
        return this.request(__assign(__assign({}, options), { path: path, method: exports.HttpMethod.Patch }));
    };
    BasicHttpClient.prototype.preRequest = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var populatedHeaders;
            return __generator(this, function (_a) {
                populatedHeaders = this.populateDefaultHeaders(request.headers);
                return [2 /*return*/, __assign(__assign({}, request), { headers: populatedHeaders })];
            });
        });
    };
    BasicHttpClient.prototype.postRequest = function (response, _, __) {
        return __awaiter(this, void 0, void 0, function () {
            var requestIsOk;
            return __generator(this, function (_a) {
                requestIsOk = BasicHttpClient.validateStatusCode(response.status);
                if (!requestIsOk) {
                    BasicHttpClient.throwCustomErrorResponse(response);
                }
                return [2 /*return*/, response];
            });
        });
    };
    BasicHttpClient.prototype.populateDefaultHeaders = function (headers) {
        if (headers === void 0) { headers = {}; }
        return __assign(__assign({}, this.defaultHeaders), headers);
    };
    BasicHttpClient.prototype.rawRequest = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var url, headers, body, res, responseHandler, resClone, _a, data, textFallback;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = this.constructUrl(request.path, request.params);
                        headers = headersWithDefaultField(request.headers || {}, 'Accept', 'application/json');
                        body = request.data;
                        if (isJson(body)) {
                            body = BasicHttpClient.transformRequestBody(body);
                            headers['Content-Type'] = 'application/json';
                        }
                        return [4 /*yield*/, fetch__default(url, {
                                // @ts-ignore
                                body: body,
                                method: request.method,
                                headers: headers,
                            })];
                    case 1:
                        res = _b.sent();
                        responseHandler = BasicHttpClient.getResponseHandler(request.responseType);
                        resClone = res.clone();
                        return [4 /*yield*/, Promise.all([
                                responseHandler(res).catch(function () { return undefined; }),
                                resClone.text(),
                            ])];
                    case 2:
                        _a = __read.apply(void 0, [_b.sent(), 2]), data = _a[0], textFallback = _a[1];
                        return [2 /*return*/, {
                                headers: BasicHttpClient.convertFetchHeaders(res.headers),
                                status: res.status,
                                data: data || textFallback,
                            }];
                }
            });
        });
    };
    BasicHttpClient.prototype.request = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var mutatedRequest, rawResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.preRequest(request)];
                    case 1:
                        mutatedRequest = _a.sent();
                        return [4 /*yield*/, this.rawRequest(mutatedRequest)];
                    case 2:
                        rawResponse = _a.sent();
                        return [2 /*return*/, this.postRequest(rawResponse, request, mutatedRequest)];
                }
            });
        });
    };
    BasicHttpClient.prototype.constructUrl = function (path, params) {
        var url = path;
        var hasQueryParams = !!params && Object.keys(params).length > 0;
        if (hasQueryParams) {
            var normalizedParams = Object.entries(params).reduce(function (acc, _a) {
                var _b = __read(_a, 2), key = _b[0], value = _b[1];
                switch (typeof value) {
                    case 'undefined': {
                        return acc;
                    }
                    case 'string':
                    case 'number':
                    case 'boolean': {
                        acc[key] = "" + value;
                        return acc;
                    }
                    case 'object': {
                        if (Array.isArray(value)) {
                            acc[key] = "[" + value.join(',') + "]";
                        }
                        return acc;
                    }
                    default: {
                        throw new Error("Unsupported value query parameter type: " + typeof value + ", " + key + ": " + value);
                    }
                }
            }, {});
            var search = new URLSearchParams(normalizedParams).toString();
            url += "?" + search;
        }
        var urlContainsHost = url.match(/^https?:\/\//i) !== null;
        if (urlContainsHost) {
            return url;
        }
        return BasicHttpClient.resolveUrl(this.baseUrl, url);
    };
    return BasicHttpClient;
}());
function lowercaseHeadersKeys(headers) {
    var keys = [];
    for (var key in headers) {
        keys.push(key.toLowerCase());
    }
    return keys;
}
function headersWithDefaultField(headers, fieldName, fieldValue) {
    var lowercaseHeaders = lowercaseHeadersKeys(headers);
    var lowercaseKey = fieldName.toLowerCase();
    if (!lowercaseHeaders.includes(lowercaseKey)) {
        headers[fieldName] = fieldValue;
    }
    return headers;
}
(function (HttpMethod) {
    HttpMethod["Get"] = "GET";
    HttpMethod["Post"] = "POST";
    HttpMethod["Put"] = "PUT";
    HttpMethod["Delete"] = "DELETE";
    HttpMethod["Patch"] = "PATCH";
})(exports.HttpMethod || (exports.HttpMethod = {}));
var HttpResponseType = {
    Json: 'json',
    ArrayBuffer: 'arraybuffer',
    Text: 'text',
};

// Copyright 2020 Cognite AS
var MAX_RETRY_ATTEMPTS = 5;
var createRetryValidator = function (endpointsToRetry, maxRetries) {
    if (maxRetries === void 0) { maxRetries = MAX_RETRY_ATTEMPTS; }
    var universalRetryValidator = createUniversalRetryValidator(maxRetries);
    return function (request, response, retryCount) {
        if (retryCount >= maxRetries) {
            return false;
        }
        if (!isValidRetryStatusCode(response.status)) {
            return false;
        }
        if (universalRetryValidator(request, response, retryCount)) {
            return true;
        }
        var endpoints = endpointsToRetry[request.method] || [];
        if (matchPathWithEndpoints(request.path, endpoints)) {
            return true;
        }
        return false;
    };
};
var createUniversalRetryValidator = function (maxRetries) {
    if (maxRetries === void 0) { maxRetries = MAX_RETRY_ATTEMPTS; }
    return function (request, response, retryCount) {
        if (retryCount >= maxRetries) {
            return false;
        }
        // Always retry http 429 too many requests
        if (response.status === 429) {
            return true;
        }
        var httpMethodsToRetry = ['GET', 'HEAD', 'OPTIONS', 'DELETE', 'PUT'];
        var isRetryableHttpMethod = httpMethodsToRetry.indexOf(request.method.toUpperCase()) !== -1;
        if (!isRetryableHttpMethod) {
            return false;
        }
        return isValidRetryStatusCode(response.status);
    };
};
function isValidRetryStatusCode(status) {
    return (inRange(status, 100, 200) ||
        inRange(status, 429, 430) ||
        inRange(status, 500, 600));
}
function matchPathWithEndpoints(path, endpoints) {
    return some(endpoints, function (endpoint) { return matchPathWithEndpoint(path, endpoint); });
}
function matchPathWithEndpoint(path, endpoint) {
    return path.toUpperCase().indexOf(endpoint.toUpperCase()) !== -1;
}

var RetryableHttpClient = /** @class */ (function (_super) {
    __extends(RetryableHttpClient, _super);
    function RetryableHttpClient(baseUrl, retryValidator) {
        var _this = _super.call(this, baseUrl) || this;
        _this.retryValidator = retryValidator;
        return _this;
    }
    RetryableHttpClient.calculateRetryDelayInMs = function (retryCount) {
        var INITIAL_RETRY_DELAY_IN_MS = 250;
        return INITIAL_RETRY_DELAY_IN_MS + ((Math.pow(2, retryCount) - 1) / 2) * 1000;
    };
    RetryableHttpClient.prototype.get = function (path, options) {
        if (options === void 0) { options = {}; }
        return _super.prototype.get.call(this, path, options);
    };
    RetryableHttpClient.prototype.post = function (path, options) {
        if (options === void 0) { options = {}; }
        return _super.prototype.post.call(this, path, options);
    };
    RetryableHttpClient.prototype.put = function (path, options) {
        if (options === void 0) { options = {}; }
        return _super.prototype.put.call(this, path, options);
    };
    RetryableHttpClient.prototype.delete = function (path, options) {
        if (options === void 0) { options = {}; }
        return _super.prototype.delete.call(this, path, options);
    };
    RetryableHttpClient.prototype.patch = function (path, options) {
        if (options === void 0) { options = {}; }
        return _super.prototype.patch.call(this, path, options);
    };
    RetryableHttpClient.prototype.preRequest = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, _super.prototype.preRequest.call(this, request)];
            });
        });
    };
    RetryableHttpClient.prototype.postRequest = function (response, request, mutatedRequest) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, _super.prototype.postRequest.call(this, response, request, mutatedRequest)];
            });
        });
    };
    RetryableHttpClient.prototype.rawRequest = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var retryCount, response, retryValidator, shouldRetry, delayInMs;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        retryCount = 0;
                        _a.label = 1;
                    case 1:
                        return [4 /*yield*/, _super.prototype.rawRequest.call(this, request)];
                    case 2:
                        response = _a.sent();
                        retryValidator = isFunction(request.retryValidator)
                            ? request.retryValidator
                            : this.retryValidator;
                        shouldRetry = retryCount < MAX_RETRY_ATTEMPTS &&
                            request.retryValidator !== false &&
                            retryValidator(request, response, retryCount);
                        if (!shouldRetry) {
                            return [2 /*return*/, response];
                        }
                        delayInMs = RetryableHttpClient.calculateRetryDelayInMs(retryCount);
                        return [4 /*yield*/, sleepPromise(delayInMs)];
                    case 3:
                        _a.sent();
                        retryCount++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    RetryableHttpClient.prototype.request = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, _super.prototype.request.call(this, request)];
            });
        });
    };
    return RetryableHttpClient;
}(BasicHttpClient));

// Copyright 2020 Cognite AS
var CDFHttpClient = /** @class */ (function (_super) {
    __extends(CDFHttpClient, _super);
    function CDFHttpClient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.oneTimeHeaders = {};
        _this.setBearerToken = function (token) {
            _this.setDefaultHeader(AUTHORIZATION_HEADER, bearerString(token));
        };
        _this.response401Handler = function (_, __, ___, reject) {
            return reject();
        };
        return _this;
    }
    CDFHttpClient.serializeQueryParameters = function (params) {
        if (params === void 0) { params = {}; }
        return Object.entries(params).reduce(function (serializedParams, _a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            serializedParams[key] = isJson(value) ? JSON.stringify(value) : value;
            return serializedParams;
        }, {});
    };
    CDFHttpClient.isSameOrigin = function (baseUrl, url) {
        var _a = new URL(baseUrl), baseUrlProtocol = _a.protocol, baseUrlHost = _a.host;
        var _b = new URL(new URL(url, baseUrl).toString()), protocol = _b.protocol, host = _b.host;
        var hasSameProtocol = baseUrlProtocol === protocol;
        var hasSameHost = baseUrlHost === host;
        return hasSameProtocol && hasSameHost;
    };
    CDFHttpClient.filterHeaders = function (headers, names) {
        return names.reduce(function (partiallyFilteredHeaders, headerName) {
            return CDFHttpClient.filterHeader(partiallyFilteredHeaders, headerName);
        }, headers);
    };
    CDFHttpClient.filterHeader = function (headers, name) {
        var filteredHeaders = __assign({}, headers);
        delete filteredHeaders[name];
        return filteredHeaders;
    };
    CDFHttpClient.prototype.addOneTimeHeader = function (name, value) {
        this.oneTimeHeaders[name] = value;
        return this;
    };
    CDFHttpClient.prototype.set401ResponseHandler = function (handler) {
        this.response401Handler = handler;
    };
    CDFHttpClient.prototype.preRequest = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var headersWithDefaultHeaders, headers, data, params;
            return __generator(this, function (_a) {
                headersWithDefaultHeaders = this.populateDefaultHeaders(request.headers);
                headers = request.withCredentials
                    ? headersWithDefaultHeaders
                    : this.preventTokenLeakage(headersWithDefaultHeaders, request.path);
                data = request.data;
                params = CDFHttpClient.serializeQueryParameters(request.params);
                return [2 /*return*/, __assign(__assign({}, request), { data: data,
                        headers: headers,
                        params: params })];
            });
        });
    };
    CDFHttpClient.prototype.request = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                request.headers = this.enrichWithOneTimeHeaders(request.headers);
                return [2 /*return*/, _super.prototype.request.call(this, request)];
            });
        });
    };
    CDFHttpClient.prototype.postRequest = function (response, request, mutatedRequest) {
        return __awaiter(this, void 0, void 0, function () {
            var err_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, _super.prototype.postRequest.call(this, response, request, mutatedRequest)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        err_1 = _a.sent();
                        if (!(err_1 instanceof HttpError)) {
                            throw err_1;
                        }
                        if (err_1.status === 401 &&
                            !this.isLoginOrLogoutApi(request.path) &&
                            !this.isTokenInspect(request.path)) {
                            return [2 /*return*/, new Promise(function (resolvePromise, rejectPromise) {
                                    var retry = function () { return resolvePromise(_this.request(request)); };
                                    var reject = function () { return rejectPromise(err_1); };
                                    _this.response401Handler(err_1, mutatedRequest, retry, reject);
                                })];
                        }
                        throw handleErrorResponse(err_1);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CDFHttpClient.prototype.enrichWithOneTimeHeaders = function (headers) {
        var disposableHeaders = this.oneTimeHeaders;
        this.oneTimeHeaders = {};
        return __assign(__assign({}, headers), disposableHeaders);
    };
    CDFHttpClient.prototype.preventTokenLeakage = function (headers, path) {
        if (CDFHttpClient.isSameOrigin(this.baseUrl, path)) {
            return headers;
        }
        return CDFHttpClient.filterHeaders(headers, [
            AUTHORIZATION_HEADER,
            API_KEY_HEADER,
            X_CDF_APP_HEADER,
            X_CDF_SDK_HEADER,
        ]);
    };
    CDFHttpClient.prototype.isLoginOrLogoutApi = function (url) {
        var lowerCaseUrl = url.toLowerCase();
        return (lowerCaseUrl.indexOf('/logout/url') !== -1 ||
            lowerCaseUrl.indexOf('/login/status') !== -1);
    };
    CDFHttpClient.prototype.isTokenInspect = function (url) {
        var lowerCaseUrl = url.toLowerCase();
        return lowerCaseUrl.indexOf('/token/inspect') !== -1;
    };
    return CDFHttpClient;
}(RetryableHttpClient));

// Copyright 2020 Cognite AS
var CogniteLoginError = /** @class */ (function (_super) {
    __extends(CogniteLoginError, _super);
    function CogniteLoginError(message) {
        var _this = _super.call(this, message || 'Not able to login') || this;
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, _this.constructor);
        }
        else {
            _this.stack = new Error(_this.message).stack;
        }
        return _this;
    }
    return CogniteLoginError;
}(Error));

// Copyright 2020 Cognite AS
var LOGIN_POPUP_NAME = 'cognite-js-sdk-auth-popup';
var LOGIN_IFRAME_NAME = 'silentLoginIframe';
var ACCESS_TOKEN_PARAM = 'access_token';
var ID_TOKEN_PARAM = 'id_token';
var ERROR_PARAM = 'error';
var ERROR_DESCRIPTION_PARAM = 'error_description';
var OPTIONS_REQUIRED_FIELDS = ['appId', 'project'];
var CREDENTIALS_REQUIRED_FIELDS = [
    { method: 'api', field: 'apiKey' },
    { method: 'client_credentials', field: 'authority' },
    { method: 'client_credentials', field: 'client_id' },
    { method: 'client_credentials', field: 'client_secret' },
    { method: 'client_credentials', field: 'scope' },
    { method: 'client_credentials', field: 'grant_type' },
    { method: 'device', field: 'authority' },
    { method: 'device', field: 'client_id' },
    { method: 'device', field: 'scope' },
    { method: 'implicit', field: 'authority' },
    { method: 'implicit', field: 'client_id' },
    { method: 'implicit', field: 'scope' },
    { method: 'pkce', field: 'authority' },
    { method: 'pkce', field: 'client_id' },
    { method: 'pkce', field: 'scope' },
];
function isLoginPopupWindow() {
    return window.name === LOGIN_POPUP_NAME;
}
function loginPopupHandler() {
    if (!isLoginPopupWindow()) {
        return;
    }
    try {
        var tokens = parseTokenQueryParameters(window.location.search);
        window.opener.postMessage(tokens);
    }
    catch (err) {
        if (err instanceof Error) {
            window.opener.postMessage({ error: err.message });
        }
        else {
            throw err;
        }
    }
    finally {
        window.close();
    }
}
/** @hidden */
function getLogoutUrl(get, params) {
    return __awaiter(this, void 0, void 0, function () {
        var response, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, get('/logout/url', {
                            params: params,
                        })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data.data.url];
                case 2:
                    err_1 = _a.sent();
                    if (err_1 instanceof CogniteError && err_1.status === 401) {
                        return [2 /*return*/, null];
                    }
                    throw err_1;
                case 3: return [2 /*return*/];
            }
        });
    });
}
/** @hidden */
function parseTokenQueryParameters(query) {
    var queryParams = new URLSearchParams(query);
    var accessToken = queryParams.get(ACCESS_TOKEN_PARAM);
    var idToken = queryParams.get(ID_TOKEN_PARAM);
    var error = queryParams.get(ERROR_PARAM);
    var errorDescription = queryParams.get(ERROR_DESCRIPTION_PARAM);
    if (error !== null) {
        throw Error(error + ": " + errorDescription);
    }
    if (isString(accessToken) && isString(idToken)) {
        return {
            accessToken: accessToken,
            idToken: idToken,
        };
    }
    return null;
}
/** @hidden */
function loginWithRedirect(params) {
    // we want to return a promise which never gets resolved (window will redirect)
    return new Promise(function () {
        var url = generateLoginUrl(params);
        window.location.assign(url);
    });
}
/** @hidden */
function loginWithPopup(params) {
    return new Promise(function (resolve, reject) {
        var url = generateLoginUrl(params);
        var loginPopup = generatePopupWindow(url, LOGIN_POPUP_NAME);
        if (loginPopup === null) {
            reject(new CogniteLoginError('Failed to create login popup window'));
            return;
        }
        var tokenListener = function (message) {
            if (message.source !== loginPopup) {
                return;
            }
            if (!message.data || message.data.error) {
                reject(new CogniteLoginError());
                return;
            }
            window.removeEventListener('message', tokenListener);
            resolve(message.data);
        };
        window.addEventListener('message', tokenListener, false);
    });
}
/** @hidden **/
function silentLoginViaIframe(url, extractor, iframeName, locationPart) {
    if (iframeName === void 0) { iframeName = LOGIN_IFRAME_NAME; }
    if (locationPart === void 0) { locationPart = 'hash'; }
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var iframe = createInvisibleIframe(url, iframeName);
                    iframe.onload = function () {
                        try {
                            if (!iframe.contentWindow) {
                                throw Error('Failed to login silently');
                            }
                            var authTokens = extractor(iframe.contentWindow.location[locationPart]);
                            if (authTokens === null) {
                                throw Error('Failed to login silently');
                            }
                            resolve(authTokens);
                        }
                        catch (e) {
                            reject(e);
                        }
                        finally {
                            document.body.removeChild(iframe);
                        }
                    };
                    document.body.appendChild(iframe);
                })];
        });
    });
}
function generateLoginUrl(params) {
    var project = params.project, baseUrl = params.baseUrl, redirectUrl = params.redirectUrl, errorRedirectUrl = params.errorRedirectUrl;
    var queryParams = {
        project: project,
        redirectUrl: redirectUrl,
        errorRedirectUrl: errorRedirectUrl || redirectUrl,
    };
    var search = new URLSearchParams(queryParams).toString();
    return baseUrl + "/login/redirect?" + search;
}
/**
 * It verify if credentials contain require fields depending each method.
 * @param credentials ClientCredentials
 */
function verifyCredentialsRequiredFields(credentials) {
    if (!isObject(credentials)) {
        throw Error('options.credentials is required');
    }
    if (!credentials.method) {
        throw Error('options.credentials.method is required and must be of type string with one of this values: api, client_credentials, device, implicit, pkce');
    }
    for (var index = 0; index < CREDENTIALS_REQUIRED_FIELDS.length; index++) {
        var field = CREDENTIALS_REQUIRED_FIELDS[index];
        if (credentials.method &&
            credentials.method === field.method &&
            // @ts-ignore
            !credentials[field.field]) {
            throw Error("options.credentials." + field.field + " is required and must be of type string");
        }
    }
}
/**
 * It verify if options contain require fields .
 * @param credentials ClientCredentials
 */
function verifyOptionsRequiredFields(options) {
    if (!isObject(options)) {
        throw Error('`CogniteClient` is missing parameter `options`');
    }
    for (var index = 0; index < OPTIONS_REQUIRED_FIELDS.length; index++) {
        var field = OPTIONS_REQUIRED_FIELDS[index];
        // @ts-ignore
        if (!isString(options[field])) {
            throw Error("options." + field + " is required and must be of type string");
        }
    }
}

// Copyright 2020 Cognite AS
var REDIRECT = 'REDIRECT';
var POPUP = 'POPUP';
/** @hidden */
function getIdInfo(get, headers) {
    return __awaiter(this, void 0, void 0, function () {
        var response, _a, loggedIn, user, project, projectId, err_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, get('/login/status', { headers: headers })];
                case 1:
                    response = _b.sent();
                    _a = response.data.data, loggedIn = _a.loggedIn, user = _a.user, project = _a.project, projectId = _a.projectId;
                    if (!loggedIn) {
                        return [2 /*return*/, null];
                    }
                    return [2 /*return*/, {
                            user: user,
                            project: project,
                            projectId: projectId,
                        }];
                case 2:
                    err_1 = _b.sent();
                    if (err_1 instanceof CogniteError && err_1.status === 401) {
                        return [2 /*return*/, null];
                    }
                    throw err_1;
                case 3: return [2 /*return*/];
            }
        });
    });
}
var CogniteAuthentication = /** @class */ (function () {
    function CogniteAuthentication(_a) {
        var project = _a.project, baseUrl = _a.baseUrl;
        if (!isString(project)) {
            throw Error('options.project is required and must be of type string');
        }
        this.baseUrl = baseUrl || getBaseUrl(baseUrl);
        this.httpClient = new CDFHttpClient(this.baseUrl, createUniversalRetryValidator());
        this.project = project;
    }
    CogniteAuthentication.prototype.login = function (_a) {
        var _this = this;
        var onAuthMethod = _a.onAuthenticate;
        var onAuthenticate = onAuthMethod === POPUP
            ? onAuthenticateWithPopup
            : isFunction(onAuthMethod)
                ? onAuthMethod
                : onAuthenticateWithRedirect;
        return new Promise(function (resolve, reject) {
            var login = {
                skip: function () {
                    resolve(null);
                },
                redirect: function (params) {
                    var authorizeParams = __assign({ baseUrl: _this.baseUrl, project: _this.project }, params);
                    loginWithRedirect(authorizeParams).catch(reject);
                },
                popup: function (params) { return __awaiter(_this, void 0, void 0, function () {
                    var authorizeParams, tokens, error_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                authorizeParams = __assign({ baseUrl: this.baseUrl, project: this.project }, params);
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, loginWithPopup(authorizeParams)];
                            case 2:
                                tokens = _a.sent();
                                if (tokens) {
                                    this.setTokens(tokens);
                                    resolve(tokens);
                                }
                                else {
                                    reject(new CogniteLoginError());
                                }
                                return [3 /*break*/, 4];
                            case 3:
                                error_1 = _a.sent();
                                reject(error_1);
                                return [3 /*break*/, 4];
                            case 4: return [2 /*return*/];
                        }
                    });
                }); },
            };
            onAuthenticate(login);
        });
    };
    CogniteAuthentication.prototype.getCDFToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, accessToken, idToken, isValid;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.authTokens) return [3 /*break*/, 2];
                        _a = this.authTokens, accessToken = _a.accessToken, idToken = _a.idToken;
                        return [4 /*yield*/, isTokensValid(this.httpClient, this.project, {
                                accessToken: accessToken,
                                idToken: idToken,
                            })];
                    case 1:
                        isValid = _b.sent();
                        if (isValid) {
                            return [2 /*return*/, { accessToken: accessToken, idToken: idToken }];
                        }
                        _b.label = 2;
                    case 2: return [2 /*return*/, null];
                }
            });
        });
    };
    CogniteAuthentication.prototype.handleLoginRedirect = function () {
        return __awaiter(this, void 0, void 0, function () {
            var tokens, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!isUsingSSL() && !isLocalhost()) {
                            return [2 /*return*/, null];
                        }
                        tokens = extractTokensFromUrl();
                        _a = tokens !== null;
                        if (!_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, isTokensValid(this.httpClient, this.project, tokens)];
                    case 1:
                        _a = (_b.sent());
                        _b.label = 2;
                    case 2:
                        if (_a) {
                            clearParametersFromUrl(ACCESS_TOKEN_PARAM, ID_TOKEN_PARAM);
                            this.setTokens(tokens);
                            return [2 /*return*/, tokens];
                        }
                        return [2 /*return*/, null];
                }
            });
        });
    };
    CogniteAuthentication.prototype.setTokens = function (_a) {
        var accessToken = _a.accessToken, idToken = _a.idToken;
        this.authTokens = { accessToken: accessToken, idToken: idToken };
    };
    return CogniteAuthentication;
}());
function extractTokensFromUrl() {
    try {
        var tokens = parseTokenQueryParameters(window.location.search);
        clearParametersFromUrl(ACCESS_TOKEN_PARAM, ID_TOKEN_PARAM);
        return tokens;
    }
    catch (err) {
        clearParametersFromUrl(ERROR_PARAM, ERROR_DESCRIPTION_PARAM);
        throw err;
    }
}
function onAuthenticateWithRedirect(login) {
    login.redirect({
        redirectUrl: window.location.href,
    });
}
function onAuthenticateWithPopup(login) {
    login.popup({
        redirectUrl: window.location.href,
    });
}
function isTokensValid(httpClient, project, tokens) {
    return __awaiter(this, void 0, void 0, function () {
        var idInfo;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getIdInfoFromAccessToken(httpClient, tokens.accessToken)];
                case 1:
                    idInfo = _a.sent();
                    return [2 /*return*/, idInfo !== null && isSameProject(idInfo.project, project)];
            }
        });
    });
}
function getIdInfoFromAccessToken(httpClient, accessToken) {
    var _a;
    return getIdInfo(httpClient.get.bind(httpClient), (_a = {},
        _a[AUTHORIZATION_HEADER] = bearerString(accessToken),
        _a));
}

// Copyright 2020 Cognite AS
var adfsRequestParamsMapping = {
    clientId: 'client_id',
    scope: 'scope',
    redirectUri: 'redirect_uri',
    responseMode: 'response_mode',
    responseType: 'response_type',
    resource: 'resource',
};
var ACCESS_TOKEN = 'access_token';
var ID_TOKEN = 'id_token';
var EXPIRES_IN = 'expires_in';
var TOKEN_TYPE = 'token_type';
var SCOPE = 'scope';
var LOGIN_IFRAME_NAME$1 = 'adfsSilentLoginIframe';
var ADFS = /** @class */ (function () {
    function ADFS(_a) {
        var authority = _a.authority, requestParams = _a.requestParams;
        this.token = null;
        this.authority = authority;
        this.queryParams = this.getADFSQueryParams(requestParams);
        this.sessionKey = authority + "_" + requestParams.clientId + "_" + requestParams.resource;
    }
    ADFS.prototype.login = function () {
        return __awaiter(this, void 0, void 0, function () {
            var token;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.acquireTokenSilently()];
                    case 1:
                        token = _a.sent();
                        return [2 /*return*/, new Promise(function (resolve) {
                                if (token) {
                                    resolve(token.accessToken);
                                }
                                var url = _this.authority + "?" + _this.getADFSQueryParamString(_this.queryParams);
                                window.location.href = url;
                            })];
                }
            });
        });
    };
    ADFS.prototype.handleLoginRedirect = function () {
        try {
            var queryParams = window.location.hash;
            if (!queryParams) {
                return null;
            }
            var token = extractADFSToken(queryParams);
            clearParametersFromUrl(ACCESS_TOKEN, ID_TOKEN, EXPIRES_IN, SCOPE, TOKEN_TYPE);
            this.setToken(token);
            return token;
        }
        catch (e) {
            console.error(e);
        }
        return null;
    };
    ADFS.prototype.getCDFToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.acquireTokenSilently()];
                    case 1:
                        token = _a.sent();
                        return [2 /*return*/, token
                                ? token.accessToken
                                : this.token
                                    ? this.token.accessToken
                                    : null];
                }
            });
        });
    };
    ADFS.prototype.getIdToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.acquireTokenSilently()];
                    case 1:
                        token = _a.sent();
                        return [2 /*return*/, token ? token.idToken : this.token ? this.token.idToken : null];
                }
            });
        });
    };
    /**
     * This method going to work only if 'X-Frame-Options' header
     * set to 'allow-from https://www.example.com' on the ADFS server.
     * And this is the only way to acquire token with ADFS silently
     * (using implicit grant flow)
     */
    ADFS.prototype.acquireTokenSilently = function () {
        return __awaiter(this, void 0, void 0, function () {
            var token, url, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        token = this.getToken();
                        if (token) {
                            return [2 /*return*/, token];
                        }
                        url = this.authority + "?prompt=none&" + this.getADFSQueryParamString(this.queryParams);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, silentLoginViaIframe(url, extractADFSToken, LOGIN_IFRAME_NAME$1)];
                    case 2:
                        token = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        noop();
                        return [3 /*break*/, 4];
                    case 4:
                        if (token) {
                            this.setToken(token);
                        }
                        return [2 /*return*/, token];
                }
            });
        });
    };
    ADFS.prototype.getADFSQueryParams = function (_a) {
        var resource = _a.resource, clientId = _a.clientId;
        var responseMode = 'fragment';
        var responseType = 'id_token token';
        var scope = 'user_impersonation IDENTITY';
        var redirectUri = window.location.href;
        var params = {
            clientId: clientId,
            scope: scope,
            responseMode: responseMode,
            responseType: responseType,
            resource: resource,
            redirectUri: redirectUri,
        };
        return Object.entries(params).reduce(function (result, _a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            var param = adfsRequestParamsMapping[key];
            result[param] = value;
            return result;
        }, {});
    };
    ADFS.prototype.getADFSQueryParamString = function (params) {
        return Object.entries(params).reduce(function (result, _a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            return "" + result + (result.length > 1 ? '&' : '') + key + "=" + value;
        }, '');
    };
    ADFS.prototype.setToken = function (token) {
        this.token = token;
        if (token) {
            sessionStorage.setItem(this.sessionKey, JSON.stringify(token));
        }
        else {
            sessionStorage.removeItem(this.sessionKey);
        }
    };
    ADFS.prototype.getToken = function () {
        var value = sessionStorage.getItem(this.sessionKey);
        if (!value) {
            return null;
        }
        try {
            var token = JSON.parse(value);
            if (token.expiresIn <= Date.now()) {
                throw new Error("token expired " + token.expiresIn);
            }
            return token;
        }
        catch (err) {
            console.error(err);
            sessionStorage.removeItem(this.sessionKey);
            return null;
        }
    };
    return ADFS;
}());
function extractADFSToken(fragment) {
    var query = fragment.replace(/^#/, '?');
    var queryParams = new URLSearchParams(query);
    var accessToken = queryParams.get(ACCESS_TOKEN);
    var idToken = queryParams.get(ID_TOKEN);
    var expiresIn = queryParams.get(EXPIRES_IN);
    if (isString(accessToken) && isString(idToken)) {
        return {
            accessToken: accessToken,
            idToken: idToken,
            expiresIn: Date.now() + Number(expiresIn) * 1000,
        };
    }
    return null;
}

/** @hidden */
var MetadataMap = /** @class */ (function () {
    function MetadataMap() {
        this.map = new WeakMap();
    }
    MetadataMap.prototype.addAndReturn = function (value, metadata) {
        this.map.set(value, {
            // we extract out only what is necessary
            status: metadata.status,
            headers: metadata.headers,
        });
        return value;
    };
    MetadataMap.prototype.get = function (value) {
        return this.map.get(value);
    };
    return MetadataMap;
}());

// Copyright 2020 Cognite AS
// polyfill
if (Symbol.asyncIterator === undefined) {
    // biome-ignore lint/suspicious/noExplicitAny: will deprecate soon when we move to es6
    Symbol.asyncIterator = Symbol.for('asyncIterator');
}
/** @hidden */
function makeAutoPaginationMethods(firstPagePromise) {
    var _a;
    var listPromise = firstPagePromise;
    var i = 0;
    function iterate(listResult) {
        if (i < listResult.items.length) {
            return {
                value: listResult.items[i++],
                done: false,
            };
        }
        if (listResult.next) {
            // reset counter, request next page, and recurse.
            i = 0;
            listPromise = listResult.next();
            return listPromise.then(iterate);
        }
        return { value: undefined, done: true };
    }
    function asyncIteratorNext() {
        return __awaiter(this, void 0, void 0, function () {
            var listResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, listPromise];
                    case 1:
                        listResult = _a.sent();
                        return [2 /*return*/, iterate(listResult)];
                }
            });
        });
    }
    var autoPagingEach = makeAutoPagingEach(asyncIteratorNext);
    var autoPagingToArray = makeAutoPagingToArray(autoPagingEach);
    var autoPaginationMethods = (_a = {
            autoPagingEach: autoPagingEach,
            autoPagingToArray: autoPagingToArray,
            // Async iterator functions:
            next: asyncIteratorNext,
            // biome-ignore lint/suspicious/noExplicitAny: didn't find the right type in reasonable timeframe
            return: function () {
                // This is required for `break`.
                return {};
            }
        },
        _a[Symbol.asyncIterator] = function () { return autoPaginationMethods; },
        _a);
    return autoPaginationMethods;
}
function makeAutoPagingEach(asyncIteratorNext) {
    return function autoPagingEach(handler) {
        return __awaiter(this, void 0, void 0, function () {
            function iterate() {
                return __awaiter(this, void 0, void 0, function () {
                    var iterResult, item, shouldContinue;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, asyncIteratorNext()];
                            case 1:
                                iterResult = _a.sent();
                                if (iterResult.done) {
                                    return [2 /*return*/];
                                }
                                item = iterResult.value;
                                return [4 /*yield*/, handler(item)];
                            case 2:
                                shouldContinue = _a.sent();
                                if (shouldContinue === false) {
                                    return [2 /*return*/];
                                }
                                return [4 /*yield*/, iterate()];
                            case 3:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, iterate()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
}
function makeAutoPagingToArray(autoPagingEach) {
    return function autoPagingToArray(options) {
        return __awaiter(this, void 0, void 0, function () {
            var limit, items;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        limit = (options === null || options === void 0 ? void 0 : options.limit) || 25;
                        if (limit === -1) {
                            limit = Number.POSITIVE_INFINITY;
                        }
                        items = [];
                        return [4 /*yield*/, autoPagingEach(function (item) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    items.push(item);
                                    if (items.length >= limit) {
                                        return [2 /*return*/, false];
                                    }
                                    return [2 /*return*/];
                                });
                            }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, items];
                }
            });
        });
    };
}

// Copyright 2020 Cognite AS
var DateParser = /** @class */ (function () {
    /**
     * @param path keys that lead to datePropNames
     * @param datePropNames keys that contain date strings or numbers representing milliseconds since epoch
     */
    function DateParser(path, datePropNames) {
        var _this = this;
        this.path = path;
        this.datePropNames = datePropNames;
        this.isDatePropName = function (key) {
            return typeof key === 'string' && _this.datePropNames.indexOf(key) !== -1;
        };
        this.isPath = function (key) {
            return typeof key === 'string' && _this.path.indexOf(key) !== -1;
        };
    }
    /**
     * Goes through data, converting all fields with paths matching
     *  (path.)*datePropNames
     * into a Date object by parsing value as milliseconds since epoch or ISO8601
     *
     * @param data
     */
    DateParser.prototype.parseToDates = function (data) {
        var _this = this;
        return cloneDeepWith(data, function (value, key, object) {
            if (_this.isDatePropName(key))
                return new Date(value);
            if (key !== undefined && !_this.isPath(key) && !Array.isArray(object)) {
                // There is a key, but it is not in lead.
                // The key is not the index of an array.
                // Return the value as is, without looking for dates
                return value;
            }
        });
    };
    /**
     * Turns every Date object in data into number of milliseconds since unix epoc
     * @param data
     */
    DateParser.parseFromDates = function (data) {
        return cloneDeepWith(data, function (value) {
            if (value instanceof Date) {
                return value.getTime();
            }
        });
    };
    return DateParser;
}());

// Copyright 2020 Cognite AS
/** @hidden */
var BaseResourceAPI = /** @class */ (function () {
    /** @hidden */
    function BaseResourceAPI(resourcePath, httpClient, map) {
        var _this = this;
        this.resourcePath = resourcePath;
        this.httpClient = httpClient;
        this.map = map;
        this.get = this.requestWrapper(this.httpClient.get.bind(this.httpClient));
        this.post = this.requestWrapper(this.httpClient.post.bind(this.httpClient));
        this.put = this.requestWrapper(this.httpClient.put.bind(this.httpClient));
        this.callListEndpointWithGet = function (scope) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get(this.listGetUrl, {
                            params: scope,
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        }); };
        this.callListEndpointWithPost = function (scope) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post(this.listPostUrl, {
                            data: scope || {},
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        }); };
        this.dateParser = new (DateParser.bind.apply(DateParser, __spread([void 0], this.getDateProps())))();
    }
    Object.defineProperty(BaseResourceAPI.prototype, "listGetUrl", {
        get: function () {
            return this.url('');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseResourceAPI.prototype, "listPostUrl", {
        get: function () {
            return this.url('list');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseResourceAPI.prototype, "byIdsUrl", {
        get: function () {
            return this.url('byids');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseResourceAPI.prototype, "updateUrl", {
        get: function () {
            return this.url('update');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseResourceAPI.prototype, "searchUrl", {
        get: function () {
            return this.url('search');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseResourceAPI.prototype, "deleteUrl", {
        get: function () {
            return this.url('delete');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseResourceAPI.prototype, "upsertUrl", {
        get: function () {
            return this.url('upsert');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseResourceAPI.prototype, "aggregateUrl", {
        get: function () {
            return this.url('aggregate');
        },
        enumerable: false,
        configurable: true
    });
    BaseResourceAPI.chunk = function (items, chunkSize) {
        if (items.length === 0) {
            return [[]];
        }
        return chunk(items, chunkSize);
    };
    BaseResourceAPI.prototype.getMetadataMap = function () {
        return this.map;
    };
    /**
     * Specifies what fields in http json responses can
     * be parsed as numbers of milliseconds since unix epoch,
     * and be converted into Date objects.
     */
    BaseResourceAPI.prototype.getDateProps = function () {
        return [[], []];
    };
    /**
     * Helper for getDateProps(...)
     *
     * @param parents list of parent property names (recursively)
     * @param props list of unix timestamp properties to be converted
     */
    BaseResourceAPI.prototype.pickDateProps = function (parents, props) {
        return [parents, props];
    };
    BaseResourceAPI.prototype.url = function (path) {
        if (path === void 0) { path = ''; }
        return this.resourcePath + "/" + path;
    };
    BaseResourceAPI.prototype.requestWrapper = function (request) {
        var _this = this;
        return function (path, options) { return __awaiter(_this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestOptions = options !== undefined
                            ? __assign(__assign({}, options), { params: DateParser.parseFromDates(options.params), data: DateParser.parseFromDates(options.data) }) : undefined;
                        return [4 /*yield*/, request(path, requestOptions)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, __assign(__assign({}, response), { data: this.dateParser.parseToDates(response.data) })];
                }
            });
        }); };
    };
    BaseResourceAPI.prototype.createEndpoint = function (items, path, preRequestModifier, postRequestModifier) {
        if (path === void 0) { path = this.url(); }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.callEndpointWithMergeAndTransform(items, function (data) { return _this.callCreateEndpoint(data, path); }, preRequestModifier, postRequestModifier)];
            });
        });
    };
    BaseResourceAPI.prototype.upsertEndpoint = function (items, preRequestModifier, postRequestModifier) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.callEndpointWithMergeAndTransform(items, function (data) { return _this.callUpsertEndpoint(data); }, preRequestModifier, postRequestModifier)];
            });
        });
    };
    BaseResourceAPI.prototype.cursorBasedEndpoint = function (endpointCaller, scope) {
        var _this = this;
        var listPromise = endpointCaller(scope).then(function (transformedResponse) {
            return _this.addNextPageFunction(endpointCaller.bind(_this), transformedResponse.data, scope);
        });
        var autoPaginationMethods = makeAutoPaginationMethods(listPromise);
        return Object.assign(listPromise, autoPaginationMethods);
    };
    BaseResourceAPI.prototype.listEndpoint = function (endpointCaller, scope) {
        return this.cursorBasedEndpoint(endpointCaller, scope);
    };
    BaseResourceAPI.prototype.retrieveEndpoint = function (ids, params, path, queryParams) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.callEndpointWithMergeAndTransform(ids, function (request) {
                        return _this.callRetrieveEndpoint(request, path, params, queryParams);
                    })];
            });
        });
    };
    BaseResourceAPI.prototype.updateEndpoint = function (changes, path) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.callEndpointWithMergeAndTransform(changes, function (data) {
                        return _this.callUpdateEndpoint(data, path);
                    })];
            });
        });
    };
    BaseResourceAPI.prototype.searchEndpoint = function (query, path, queryParams) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.callEndpointWithTransform(query, function (data) {
                        return _this.callSearchEndpoint(data, path, queryParams);
                    })];
            });
        });
    };
    BaseResourceAPI.prototype.deleteEndpoint = function (ids, params, path) {
        return __awaiter(this, void 0, void 0, function () {
            var responses;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.callDeleteEndpoint(ids, params, path)];
                    case 1:
                        responses = _a.sent();
                        return [2 /*return*/, this.addToMapAndReturn({}, responses[0])];
                }
            });
        });
    };
    BaseResourceAPI.prototype.aggregateEndpoint = function (query, path) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.callAggregateEndpoint(query, path)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.addToMapAndReturn(response.data.items, response)];
                }
            });
        });
    };
    BaseResourceAPI.prototype.callRetrieveEndpoint = function (items, path, params, queryParams) {
        if (path === void 0) { path = this.byIdsUrl; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.postInParallelWithAutomaticChunking({
                        params: params,
                        path: path,
                        items: items,
                        queryParams: queryParams,
                    })];
            });
        });
    };
    BaseResourceAPI.prototype.callUpdateEndpoint = function (changes, path) {
        if (path === void 0) { path = this.updateUrl; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.postInParallelWithAutomaticChunking({ path: path, items: changes })];
            });
        });
    };
    BaseResourceAPI.prototype.callSearchEndpoint = function (query, path, queryParams) {
        if (path === void 0) { path = this.searchUrl; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.post(path, { data: query, params: queryParams })];
            });
        });
    };
    BaseResourceAPI.prototype.callDeleteEndpoint = function (ids, params, path) {
        if (path === void 0) { path = this.deleteUrl; }
        return this.postInParallelWithAutomaticChunking({
            path: path,
            items: ids,
            params: params,
        });
    };
    BaseResourceAPI.prototype.callAggregateEndpoint = function (query, path) {
        if (path === void 0) { path = this.aggregateUrl; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.post(path, {
                        data: query,
                    })];
            });
        });
    };
    BaseResourceAPI.prototype.addToMapAndReturn = function (response, metadata) {
        return this.map.addAndReturn(response, metadata);
    };
    BaseResourceAPI.prototype.callEndpointWithMergeAndTransform = function (query, requester, preRequestModifier, postRequestModifier) {
        return __awaiter(this, void 0, void 0, function () {
            var modifiedQuery, responses, mergedResponseItems, modifiedResponseItems;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        modifiedQuery = applyIfApplicable(query, preRequestModifier);
                        return [4 /*yield*/, requester.bind(this)(modifiedQuery)];
                    case 1:
                        responses = _a.sent();
                        mergedResponseItems = this.mergeItemsFromItemsResponse(responses);
                        modifiedResponseItems = applyIfApplicable(mergedResponseItems, postRequestModifier);
                        return [2 /*return*/, this.addToMapAndReturn(modifiedResponseItems, responses[0])];
                }
            });
        });
    };
    BaseResourceAPI.prototype.callEndpointWithTransform = function (query, requester) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, requester.bind(this)(query)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.addToMapAndReturn(response.data.items, response)];
                }
            });
        });
    };
    BaseResourceAPI.prototype.mergeItemsFromItemsResponse = function (responses) {
        return responses
            .map(function (response) { return response.data.items; })
            .reduce(function (acc, cur) {
            acc.push.apply(acc, __spread(cur));
            return acc;
        }, []);
    };
    BaseResourceAPI.prototype.addNextPageFunction = function (endpoint, cursorResponse, query) {
        var _this = this;
        if (query === void 0) { query = {}; }
        var nextCursor = cursorResponse.nextCursor;
        var next = nextCursor
            ? function () {
                return endpoint(__assign(__assign({}, query), { cursor: nextCursor })).then(function (response) {
                    return _this.addNextPageFunction(endpoint, response.data, query);
                });
            }
            : undefined;
        return __assign(__assign({}, cursorResponse), { next: next });
    };
    BaseResourceAPI.prototype.postInParallelWithAutomaticChunking = function (_a) {
        var _this = this;
        var path = _a.path, items = _a.items, params = _a.params, queryParams = _a.queryParams, _b = _a.chunkSize, chunkSize = _b === void 0 ? 1000 : _b;
        return promiseAllWithData(BaseResourceAPI.chunk(items, chunkSize), function (singleChunk) {
            return _this.post(path, {
                data: __assign(__assign({}, params), { items: singleChunk }),
                params: queryParams,
            });
        }, false);
    };
    BaseResourceAPI.prototype.callCreateEndpoint = function (items, path) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.postInSequenceWithAutomaticChunking(path, items)];
            });
        });
    };
    BaseResourceAPI.prototype.callUpsertEndpoint = function (items, path) {
        if (path === void 0) { path = this.upsertUrl; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.postInSequenceWithAutomaticChunking(path, items)];
            });
        });
    };
    BaseResourceAPI.prototype.postInSequenceWithAutomaticChunking = function (path, items, params) {
        var _this = this;
        return promiseAllWithData(BaseResourceAPI.chunk(items, 1000), function (singleChunk) {
            return _this.post(path, {
                data: { items: singleChunk },
                params: params,
            });
        }, true);
    };
    return BaseResourceAPI;
}());

var version="4.10.6";

// Copyright 2020 Cognite AS
var LoginAPI = /** @class */ (function (_super) {
    __extends(LoginAPI, _super);
    /** @hidden */
    function LoginAPI(httpClient, map) {
        var _this = _super.call(this, '', httpClient, map) || this;
        /**
         * [Check login status](https://doc.cognitedata.com/api/v1/#operation/status)
         *
         * ```js
         * const status = await client.login.status();
         * // if status === null means you are not logged in
         * ```
         */
        _this.status = function () {
            return getIdInfo(_this.get, {});
        };
        return _this;
    }
    return LoginAPI;
}(BaseResourceAPI));

// Copyright 2020 Cognite AS
var LogoutApi = /** @class */ (function (_super) {
    __extends(LogoutApi, _super);
    /** @hidden */
    function LogoutApi(httpClient, map) {
        var _this = _super.call(this, '', httpClient, map) || this;
        /**
         * [Retrieve a logout url](https://docs.cognite.com/api/v1/#operation/logoutUrl)
         *
         * ```js
         * // You can specify the url to send the user to after the logout is successful.
         * // If no url is passed, you will end up at the IDPs log out page.
         * const logoutUrl = await client.logout.getUrl({ redirectUrl: '[url to redirect]' });
         * ```
         */
        _this.getUrl = function (options) {
            if (options === void 0) { options = {}; }
            return getLogoutUrl(_this.get, options);
        };
        return _this;
    }
    return LogoutApi;
}(BaseResourceAPI));

// Copyright 2022 Cognite AS
var CredentialsAuth = /** @class */ (function () {
    function CredentialsAuth(httpClient, credentials, authProvider) {
        var _this = this;
        this.httpClient = httpClient;
        this.credentials = credentials;
        this.authProvider = authProvider;
        this.tokenCredentials = {};
        this.authenticate = function () { return __awaiter(_this, void 0, void 0, function () {
            var token_1, _a, _b, token, e_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 5, , 6]);
                        if (!this.credentials)
                            return [2 /*return*/];
                        if (this.credentials.method === 'api') {
                            token_1 = this.credentials.apiKey;
                            this.httpClient.setDefaultHeader(API_KEY_HEADER, token_1);
                            return [2 /*return*/, token_1];
                        }
                        if (this.tokenCredentials.refresh_token) {
                            this.tokenCredentials.access_token = '';
                        }
                        if (!!this.credentials.authContext) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.authProvider
                                .load(this.credentials.method, this.credentials)
                                .login(this.isRefreshToken())];
                    case 1:
                        _a.tokenCredentials = _c.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        _b = this;
                        return [4 /*yield*/, this.authProvider
                                .load(this.credentials.method, this.credentials.authContext)
                                .login(this.isRefreshToken())];
                    case 3:
                        _b.tokenCredentials = _c.sent();
                        _c.label = 4;
                    case 4:
                        token = void 0;
                        if (this.tokenCredentials.access_token !== undefined &&
                            this.tokenCredentials.access_token !== '') {
                            token = this.tokenCredentials.access_token;
                            this.httpClient.setDefaultHeader(AUTHORIZATION_HEADER, bearerString(token));
                        }
                        return [2 /*return*/, token];
                    case 5:
                        e_1 = _c.sent();
                        console.error("An error ocurred while attempting to authenticate", e_1);
                        return [2 /*return*/];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        this.process();
    }
    CredentialsAuth.prototype.process = function () {
        var _a;
        if (this.credentials) {
            if (this.authProvider && isFunction(this.authProvider.requires)) {
                this.authProvider.requires(this.credentials);
            }
            else {
                verifyCredentialsRequiredFields(this.credentials);
            }
            if (((_a = this.credentials) === null || _a === void 0 ? void 0 : _a.method) !== 'api' && !this.authProvider) {
                throw Error('options.authentication.authProvider is required and must be a class that implements a static load method and can call a login method.');
            }
        }
        if (this.authProvider && !isFunction(this.authProvider.load)) {
            throw Error('The authProvider needs to have a load method.');
        }
        if (this.authProvider && !isFunction(this.authProvider.load().login)) {
            throw Error('The authProvider load method needs to be able to call call a login method.');
        }
        if (this.authProvider === undefined)
            return;
        if (this.credentials) {
            if (!this.credentials.authContext &&
                !this.authProvider.load(true, true).method &&
                !this.authProvider.load(true, true).settings) {
                throw Error('Please, use the recommended authProvider: @cognite/auth-wrapper');
            }
            else if (this.credentials.authContext &&
                !this.authProvider.load(true, true).method &&
                !this.authProvider.load(true, true).authContext) {
                throw Error('Please, use the recommended authProvider: @cognite/react-auth-wrapper');
            }
        }
    };
    CredentialsAuth.prototype.isRefreshToken = function () {
        var _a, _b;
        return ((((_a = this.credentials) === null || _a === void 0 ? void 0 : _a.method) === 'device' ||
            ((_b = this.credentials) === null || _b === void 0 ? void 0 : _b.method) === 'pkce') &&
            this.tokenCredentials.refresh_token);
    };
    CredentialsAuth.prototype.isApiKeyMode = function () {
        var _a;
        return ((_a = this.credentials) === null || _a === void 0 ? void 0 : _a.method) === 'api';
    };
    return CredentialsAuth;
}());

// Copyright 2020 Cognite AS
function accessApi(api) {
    if (api === undefined) {
        throw Error('API not found');
    }
    return api;
}
var BaseCogniteClient = /** @class */ (function () {
    /**
     * Create a new SDK client
     *
     * @param options Client options
     *
     * ```js
     * import { CogniteClient } from '@cognite/sdk';
     *
     * const client = new CogniteClient({ appId: 'YOUR APPLICATION NAME' });
     *
     * // can also specify a base URL
     * const client = new CogniteClient({ ..., baseUrl: 'https://greenfield.cognitedata.com' });
     * ```
     */
    function BaseCogniteClient(options, apiVersion) {
        var _this = this;
        if (apiVersion === void 0) { apiVersion = 'v1'; }
        var _a, _b;
        this.authenticate = function () { return __awaiter(_this, void 0, void 0, function () {
            var token, e_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.authenticateGetToken()];
                    case 1:
                        token = _b.sent();
                        if (token !== undefined) {
                            return [2 /*return*/, token];
                        }
                        return [4 /*yield*/, ((_a = this.credentialsAuth) === null || _a === void 0 ? void 0 : _a.authenticate())];
                    case 2:
                        token = _b.sent();
                        return [2 /*return*/, token];
                    case 3:
                        e_1 = _b.sent();
                        return [2 /*return*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.authenticateGetToken = function () { return __awaiter(_this, void 0, void 0, function () {
            var token, bearer, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        if (!this.tokenPromise || this.isTokenPromiseFulfilled) {
                            this.isTokenPromiseFulfilled = false;
                            this.tokenPromise = this.getToken();
                        }
                        return [4 /*yield*/, this.tokenPromise];
                    case 1:
                        token = _b.sent();
                        this.isTokenPromiseFulfilled = true;
                        if (token === undefined)
                            return [2 /*return*/, token];
                        if (this.noAuthMode) {
                            return [2 /*return*/, token];
                        }
                        if (this.apiKeyMode) {
                            this.httpClient.setDefaultHeader(API_KEY_HEADER, token);
                            return [2 /*return*/, token];
                        }
                        bearer = bearerString(token);
                        this.httpClient.setDefaultHeader(AUTHORIZATION_HEADER, bearer);
                        return [2 /*return*/, token];
                    case 2:
                        _a = _b.sent();
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        /**
         * Lookup response metadata from an request using the response as the parameter
         *
         * ```js
         * const createdAsset = await client.assets.create([{ name: 'My first asset' }]);
         * const metadata = client.getMetadata(createdAsset);
         * ```
         */
        this.getMetadata = function (value) { return _this.metadataMap.get(value); };
        /**
         * Basic HTTP method for GET
         *
         * @param path The URL path
         * @param options Request options, optional
         *
         * ```js
         * const response = await client.get('/api/v1/projects/{project}/assets', { params: { limit: 50 }});
         * ```
         */
        this.get = function (path, options) { return _this.httpClient.get(path, options); };
        /**
         * Basic HTTP method for PUT
         *
         * @param path The URL path
         * @param options Request options, optional
         *
         * ```js
         * const response = await client.put('someUrl');
         * ```
         */
        this.put = function (path, options) { return _this.httpClient.put(path, options); };
        /**
         * Basic HTTP method for POST
         *
         * @param path The URL path
         * @param options Request options, optional
         *
         * ```js
         * const assets = [{ name: 'First asset' }, { name: 'Second asset' }];
         * const response = await client.post('/api/v1/projects/{project}/assets', { data: { items: assets } });
         * ```
         */
        this.post = function (path, options) { return _this.httpClient.post(path, options); };
        /**
         * Basic HTTP method for DELETE
         *
         * @param path The URL path
         * @param options Request options, optional
         * ```js
         * const response = await client.delete('someUrl');
         * ```
         */
        this.delete = function (path, options) { return _this.httpClient.delete(path, options); };
        /**
         * Basic HTTP method for PATCH
         *
         * @param path The URL path
         * @param options Request options, optional
         * ```js
         * const response = await client.patch('someUrl');
         * ```
         */
        this.patch = function (path, options) { return _this.httpClient.patch(path, options); };
        this.apiFactory = function (api, relativePath) {
            return new api(_this.projectUrl + "/" + relativePath, _this.httpClient, _this.metadataMap);
        };
        verifyOptionsRequiredFields(options);
        if (options &&
            !((_a = options.authentication) === null || _a === void 0 ? void 0 : _a.credentials) &&
            !options.getToken &&
            !options.noAuthMode) {
            throw Error('options.authentication.credentials is required or options.getToken is request and must be of type () => Promise<string>');
        }
        var baseUrl = options.baseUrl;
        this.retryValidator = (_b = options.retryValidator) !== null && _b !== void 0 ? _b : createUniversalRetryValidator();
        this.http = this.initializeCDFHttpClient(baseUrl, options);
        if (options.authentication) {
            var _c = options.authentication, credentials = _c.credentials, provider = _c.provider;
            this.credentialsAuth = new CredentialsAuth(this.httpClient, credentials, provider);
        }
        if (isBrowser() && !isUsingSSL() && !options.noAuthMode) {
            console.warn('You should use SSL (https) when you login with OAuth since CDF only allows redirecting back to an HTTPS site');
        }
        this.metadata = new MetadataMap();
        this.loginApi = new LoginAPI(this.httpClient, this.metadataMap);
        this.logoutApi = new LogoutApi(this.httpClient, this.metadataMap);
        this.apiVersion = apiVersion;
        this.project = options.project;
        this.apiKeyMode = !!options.apiKeyMode;
        this.noAuthMode = !!options.noAuthMode;
        this.getToken = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, options.getToken ? options.getToken() : undefined];
            });
        }); };
        this.initAPIs();
    }
    Object.defineProperty(BaseCogniteClient.prototype, "login", {
        /**
         * @deprecated
         */
        get: function () {
            return this.loginApi;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseCogniteClient.prototype, "logout", {
        /**
         * @deprecated
         */
        get: function () {
            return this.logoutApi;
        },
        enumerable: false,
        configurable: true
    });
    BaseCogniteClient.prototype.initializeCDFHttpClient = function (baseUrl, options) {
        var _this = this;
        var httpClient = new CDFHttpClient(getBaseUrl(baseUrl), this.getRetryValidator());
        httpClient
            .setDefaultHeader(X_CDF_APP_HEADER, options.appId)
            .setDefaultHeader(X_CDF_SDK_HEADER, "CogniteJavaScriptSDK:" + this.version);
        httpClient.set401ResponseHandler(function (_, request, retry, reject) { return __awaiter(_this, void 0, void 0, function () {
            var requestToken, currentToken, newToken, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 5, , 6]);
                        requestToken = this.retrieveTokenValueFromHeader(request.headers);
                        return [4 /*yield*/, this.tokenPromise];
                    case 1:
                        currentToken = _c.sent();
                        if (!(currentToken !== requestToken)) return [3 /*break*/, 2];
                        _a = currentToken;
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.authenticate()];
                    case 3:
                        _a = _c.sent();
                        _c.label = 4;
                    case 4:
                        newToken = _a;
                        if (newToken && newToken !== requestToken) {
                            retry();
                        }
                        else {
                            reject();
                        }
                        return [3 /*break*/, 6];
                    case 5:
                        _b = _c.sent();
                        reject();
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        }); });
        return httpClient;
    };
    /**
     * It retrieves the previous token from header
     * @returns string
     */
    BaseCogniteClient.prototype.retrieveTokenValueFromHeader = function (headers) {
        var token;
        if (this.apiKeyMode) {
            token = headers === null || headers === void 0 ? void 0 : headers[API_KEY_HEADER];
        }
        else {
            token = headers === null || headers === void 0 ? void 0 : headers[AUTHORIZATION_HEADER];
        }
        return token !== undefined ? token.replace('Bearer ', '') : token;
    };
    /**
     * Returns the base-url used for all requests.
     */
    BaseCogniteClient.prototype.getBaseUrl = function () {
        return this.httpClient.getBaseUrl();
    };
    /**
     * Returns the default HTTP request headers, including e.g. authentication
     * headers that is included in all requests. Headers provided per-requests is not
     * included in this list. This function is useful when constructing API requests
     * outside the SDK.
     *
     * ```js
     * const customUrl = '...';
     * const headers = client.getDefaultRequestHeaders();
     * const result = await fetch(customUrl, { headers });
     * ```
     */
    BaseCogniteClient.prototype.getDefaultRequestHeaders = function () {
        return __assign({}, this.httpClient.getDefaultHeaders());
    };
    BaseCogniteClient.prototype.initAPIs = function () {
        // will be overritten by subclasses
    };
    /**
     * Returns the retry validator to be used in the http client.
     * Override to provide a better validator
     */
    BaseCogniteClient.prototype.getRetryValidator = function () {
        return this.retryValidator;
    };
    Object.defineProperty(BaseCogniteClient.prototype, "version", {
        get: function () {
            return version + "-core";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseCogniteClient.prototype, "projectUrl", {
        get: function () {
            return projectUrl(this.project, this.apiVersion);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseCogniteClient.prototype, "metadataMap", {
        get: function () {
            return this.metadata;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseCogniteClient.prototype, "httpClient", {
        get: function () {
            return this.http;
        },
        enumerable: false,
        configurable: true
    });
    return BaseCogniteClient;
}());

// Copyright 2020 Cognite AS
var RevertableArraySorter = /** @class */ (function () {
    function RevertableArraySorter(sortFunction) {
        var _this = this;
        this.sortFunction = sortFunction;
        this.originalIndexMap = new Map();
        this.sort = function (array) {
            _this.originalIndexMap = new Map();
            _this.originalArray = array;
            array.forEach(function (item, index) {
                _this.originalIndexMap.set(item, index);
            });
            _this.sortedArray = _this.sortFunction(array);
            return _this.sortedArray;
        };
        this.unsort = function (arrayToUnsort) {
            if (!_this.originalArray || !_this.sortedArray) {
                throw Error('Impossible to unsort. Call sort(...) first.');
            }
            if (arrayToUnsort.length !== _this.originalArray.length) {
                throw Error('Impossible to unsort. Input array has a different length from original.');
            }
            var originallySortedArray = [];
            _this.sortedArray.forEach(function (item, index) {
                var originalIndex = _this.originalIndexMap.get(item); // we know it exists
                originallySortedArray[originalIndex] = arrayToUnsort[index];
            });
            return originallySortedArray;
        };
    }
    return RevertableArraySorter;
}());

exports.ADFS = ADFS;
exports.BaseCogniteClient = BaseCogniteClient;
exports.BaseResourceAPI = BaseResourceAPI;
exports.BasicHttpClient = BasicHttpClient;
exports.CDFHttpClient = CDFHttpClient;
exports.CogniteAuthentication = CogniteAuthentication;
exports.CogniteError = CogniteError;
exports.CogniteLoginError = CogniteLoginError;
exports.CogniteMultiError = CogniteMultiError;
exports.Constants = constants;
exports.DateParser = DateParser;
exports.GraphUtils = graphUtils;
exports.HttpError = HttpError;
exports.HttpResponseType = HttpResponseType;
exports.MetadataMap = MetadataMap;
exports.POPUP = POPUP;
exports.REDIRECT = REDIRECT;
exports.RetryableHttpClient = RetryableHttpClient;
exports.RevertableArraySorter = RevertableArraySorter;
exports.accessApi = accessApi;
exports.apiUrl = apiUrl;
exports.createRetryValidator = createRetryValidator;
exports.createUniversalRetryValidator = createUniversalRetryValidator;
exports.getIdInfo = getIdInfo;
exports.getLogoutUrl = getLogoutUrl;
exports.isLoginPopupWindow = isLoginPopupWindow;
exports.loginPopupHandler = loginPopupHandler;
exports.promiseAllAtOnce = promiseAllAtOnce;
exports.promiseAllWithData = promiseAllWithData;
exports.promiseEachInSequence = promiseEachInSequence;
exports.sleepPromise = sleepPromise;
//# sourceMappingURL=index.js.map
